import { render } from "./TopicToBeCovered.vue?vue&type=template&id=e665e7e2"
import script from "./TopicToBeCovered.vue?vue&type=script&lang=js"
export * from "./TopicToBeCovered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__